// Auto-generated translation data (clBatch6) — Fase 2: páginas (LC-08,09,12,13,15,16).
// Pure data only. Keys 1:1 es/en; namespace por defecto 'common'. pt usa fallback a es.

export const es = {
  vender: {
    breadcrumb: 'Vende o alquila con nosotros',
    seoTitle: 'Vende o alquila con {{name}}',
    fallbackName: 'nosotros',
    seoDescription: 'Captamos tu inmueble en exclusiva con valoración gratuita, fotografía profesional y publicación en los principales portales.',
    heroTitle: '¿Vendes o alquilas? Te ayudamos a captar tu inmueble.',
    heroText: 'Trabajamos con captación local, valoración honesta y máxima visibilidad en portales. Cuéntanos sobre tu inmueble y un asesor te contactará en menos de 24h.',
    bullet0Title: 'Valoración gratuita y realista',
    bullet0Text: 'Sin compromiso. Un asesor te dice a qué precio se vende o alquila un inmueble como el tuyo en tu zona.',
    bullet1Title: 'Fotografía profesional incluida',
    bullet1Text: 'Si nos confías la captación, hacemos las fotos profesionales sin coste para ti.',
    bullet2Title: 'Publicación en los principales portales',
    bullet2Text: 'Idealista, Fotocasa, pisos.com y nuestra propia red de clientes activos.',
    bullet3Title: 'Gestor único asignado',
    bullet3Text: 'Un solo agente lleva tu inmueble de principio a fin: filtrado de visitas, negociación y cierre.',
    noteTitle: '¿Solo quieres saber cuánto vale?',
    noteText: 'Marca "Quiero recibir una valoración gratuita" en el formulario y un asesor te contactará con un rango orientativo sin compromiso.',
    loadingForm: 'Cargando formulario…',
  },
  tasacion: {
    breadcrumb: 'Tasación gratuita',
    seoTitle: 'Tasación gratuita | {{name}}',
    seoDescription: 'Obtén una valoración orientativa de tu inmueble al instante. Sin compromiso.',
    heroTitle: '¿Cuánto vale tu inmueble?',
    heroSubtitle: 'Te damos una horquilla orientativa al instante a partir de los datos de tu inmueble. Si quieres una tasación oficial firmada, te la tramitamos sin compromiso.',
    bullets: [
      { title: 'Resultado inmediato', text: 'Rellena el formulario y verás tu estimación en pantalla en segundos.' },
      { title: 'Estimación transparente', text: 'Calculamos la horquilla a partir de la ciudad, el tipo, la superficie, la antigüedad y el estado de tu inmueble.' },
      { title: 'Sin compromiso', text: 'No te llamamos a vender. Tú decides si quieres avanzar con una tasación oficial.' },
      { title: 'Tasación oficial opcional', text: 'Si necesitas un informe firmado para banco o herencia, lo gestionamos.' },
    ],
    sellRentTitle: '¿Vas a vender o alquilar?',
    sellRentText: 'Tras la tasación, un asesor puede ayudarte a captar tu inmueble en exclusiva con fotos profesionales y publicación en portales.',
    loadingForm: 'Cargando formulario…',
  },
  propertyDetail: {
    breadcrumbProperties: 'Propiedades',
    breadcrumbLoading: 'Cargando…',
    loadingProperty: 'Cargando propiedad…',
    breadcrumbNotFound: 'No encontrada',
    notFoundTitle: 'Propiedad no encontrada',
    notFoundDescription: 'La propiedad que buscas no existe o ha sido removida.',
    viewOtherProperties: 'Ver Otras Propiedades',
    breadcrumbSales: 'Ventas',
    breadcrumbRent: 'Alquiler',
    saleBadge: 'VENTA',
    rentBadge: 'ALQUILER',
    featuredBadge: 'DESTACADO',
    discardActive: 'Descartada',
    discard: 'Descartar',
    share: 'Compartir',
    favoriteActive: 'Favorita',
    favorite: 'Favorito',
    bedrooms: 'Dormitorios',
    bathrooms: 'Baños',
    area: 'Superficie',
    builtArea: 'Construidos',
    videoNotSupported: 'Tu navegador no soporta vídeo HTML5.',
    perMonth: '/mes',
    descriptionTitle: 'Descripción',
    featuresTitle: 'Equipamiento',
    locationTitle: 'Ubicación',
    viewOnOpenStreetMap: 'Ver en OpenStreetMap →',
    agentTitle: 'Agente Inmobiliario',
    agentRole: 'Agente de Ventas',
    call: 'Llamar',
    email: 'Email',
    requestInfoTitle: 'Solicitar Información',
    shareProperty: 'Compartir Propiedad',
    savedActive: 'Guardada',
    save: 'Guardar',
    similarProperties: 'Propiedades Similares',
    reference: 'Referencia:',
    reportSubject: 'Error en anuncio {{ref}}',
    reportBody: 'Hola, quiero reportar un posible error en el anuncio "{{title}}" (referencia {{ref}}).\n\nDescripción del error:\n',
    reportError: '¿Hay algún error en el anuncio?',
  },
  contactoPage: {
    breadcrumb: 'Contacto',
    loading: 'Cargando…',
    heroTitleDefault: 'Contáctanos',
    heroSubtitleDefault: 'Estamos aquí para ayudarte con todas tus necesidades inmobiliarias',
    seoTitleDefault: 'Contacto',
    seoDescriptionDefault: 'Contáctanos para todas tus necesidades inmobiliarias',
    seoKeywordsDefault: 'contacto inmobiliaria, oficinas inmobiliaria',
    talkHeading: '¿Hablamos?',
    talkSubtitle: 'Cuéntanos qué necesitas y nuestro equipo te responderá lo antes posible.',
    writeToUsTitle: 'Escríbenos',
    writeToUsSubtitle: 'Rellena el formulario y te contactaremos en menos de 24h.',
    contactInfoTitle: 'Información de contacto',
    phoneLabel: 'Teléfono',
    callNow: 'Llamar ahora',
    emailLabel: 'Email',
    sendEmail: 'Enviar email',
    openWhatsApp: 'Abrir WhatsApp',
    officeLabel: 'Oficina',
    portalsHeading: 'También nos encuentras en',
    portalsSubtitle: 'Estamos presentes en los principales portales inmobiliarios para que veas nuestras propiedades donde más cómodo te resulte.',
    viewProfile: 'Ver perfil',
    messageSentHeading: '¡Mensaje Enviado!',
    sendAnotherMessage: 'Enviar Otro Mensaje',
    selectOption: 'Selecciona una opción',
    mainOffice: 'Oficina Principal',
    officeImageAlt: 'Oficina {{city}}',
    managerLabel: 'Gerente: {{name}}',
    scheduleTitle: 'Horarios:',
    scheduleWeekdays: 'L-V: {{hours}}',
    scheduleSaturday: 'Sáb: {{hours}}',
    scheduleSunday: 'Dom: {{hours}}',
    call: 'Llamar',
    viewMap: 'Ver Mapa',
    portalDefaultIdealistaDesc: 'Encuentra nuestras propiedades en el portal inmobiliario líder de España.',
    portalDefaultFotocasaDesc: 'También publicamos nuestras viviendas en Fotocasa.',
    portalDefaultHabitacliaDesc: 'Compra, venta y alquiler de pisos publicados en Habitaclia.',
    portalCidenarIdealistaDesc: 'Todas nuestras propiedades en el portal inmobiliario líder de España.',
    portalCidenarFotocasaDesc: 'Encuentra nuestras viviendas en Pamplona y Navarra en Fotocasa.',
    portalCidenarHabitacliaDesc: 'Compra, venta y alquiler de pisos en Navarra publicados también en Habitaclia.',
  },
  home: {
    siteLoadError: 'No se pudo cargar el sitio.',
    featuredTitle: 'Propiedades destacadas',
    contactTitle: 'Contáctanos',
    phoneLabel: 'Teléfono',
    emailLabel: 'Correo electrónico',
    whatsappLabel: 'WhatsApp',
    addressLabel: 'Dirección',
  },
  quienesSomosPage: {
    fallbackHeroTitle: 'Quiénes Somos',
    fallbackHeroSubtitle: '15 años construyendo confianza en el sector inmobiliario',
    fallbackSeoDescription: 'Conoce nuestra historia, equipo y valores',
    fallbackSeoKeywords: 'quienes somos, historia inmobiliaria, equipo profesional',
    loading: 'Cargando…',
  },
};

export const en = {
  vender: {
    breadcrumb: 'Sell or rent with us',
    seoTitle: 'Sell or rent with {{name}}',
    fallbackName: 'us',
    seoDescription: 'We list your property exclusively with a free valuation, professional photography and publication on the leading portals.',
    heroTitle: 'Selling or renting? We\'ll help you list your property.',
    heroText: 'We work with local acquisition, honest valuations and maximum visibility on portals. Tell us about your property and an advisor will get back to you in under 24h.',
    bullet0Title: 'Free, realistic valuation',
    bullet0Text: 'No commitment. An advisor tells you the price a property like yours sells or rents for in your area.',
    bullet1Title: 'Professional photography included',
    bullet1Text: 'If you entrust us with the listing, we take the professional photos at no cost to you.',
    bullet2Title: 'Publication on the leading portals',
    bullet2Text: 'Idealista, Fotocasa, pisos.com and our own network of active clients.',
    bullet3Title: 'A single dedicated manager',
    bullet3Text: 'One agent handles your property from start to finish: screening visits, negotiation and closing.',
    noteTitle: 'Just want to know how much it\'s worth?',
    noteText: 'Tick "I want to receive a free valuation" on the form and an advisor will contact you with an approximate range, no commitment.',
    loadingForm: 'Loading form…',
  },
  tasacion: {
    breadcrumb: 'Free valuation',
    seoTitle: 'Free valuation | {{name}}',
    seoDescription: 'Get an indicative valuation of your property instantly. No commitment.',
    heroTitle: 'How much is your property worth?',
    heroSubtitle: 'We give you an indicative price range instantly from your property details. If you want a signed official appraisal, we\'ll arrange it for you with no commitment.',
    bullets: [
      { title: 'Instant result', text: 'Fill in the form and see your estimate on screen in seconds.' },
      { title: 'Transparent estimate', text: 'We work out the range from the city, property type, floor area, year built and condition of your property.' },
      { title: 'No commitment', text: 'We won\'t call you to sell. You decide whether you want to proceed with an official appraisal.' },
      { title: 'Optional official appraisal', text: 'If you need a signed report for a bank or inheritance, we\'ll handle it.' },
    ],
    sellRentTitle: 'Thinking of selling or renting?',
    sellRentText: 'After the valuation, an advisor can help you list your property exclusively with professional photos and publication on property portals.',
    loadingForm: 'Loading form…',
  },
  propertyDetail: {
    breadcrumbProperties: 'Properties',
    breadcrumbLoading: 'Loading…',
    loadingProperty: 'Loading property…',
    breadcrumbNotFound: 'Not found',
    notFoundTitle: 'Property not found',
    notFoundDescription: 'The property you are looking for does not exist or has been removed.',
    viewOtherProperties: 'View Other Properties',
    breadcrumbSales: 'Sales',
    breadcrumbRent: 'Rent',
    saleBadge: 'FOR SALE',
    rentBadge: 'FOR RENT',
    featuredBadge: 'FEATURED',
    discardActive: 'Discarded',
    discard: 'Discard',
    share: 'Share',
    favoriteActive: 'Favorite',
    favorite: 'Favorite',
    bedrooms: 'Bedrooms',
    bathrooms: 'Bathrooms',
    area: 'Area',
    builtArea: 'Built',
    videoNotSupported: 'Your browser does not support HTML5 video.',
    perMonth: '/month',
    descriptionTitle: 'Description',
    featuresTitle: 'Features',
    locationTitle: 'Location',
    viewOnOpenStreetMap: 'View on OpenStreetMap →',
    agentTitle: 'Real Estate Agent',
    agentRole: 'Sales Agent',
    call: 'Call',
    email: 'Email',
    requestInfoTitle: 'Request Information',
    shareProperty: 'Share Property',
    savedActive: 'Saved',
    save: 'Save',
    similarProperties: 'Similar Properties',
    reference: 'Reference:',
    reportSubject: 'Error in listing {{ref}}',
    reportBody: 'Hi, I would like to report a possible error in the listing "{{title}}" (reference {{ref}}).\n\nError description:\n',
    reportError: 'Is there an error in the listing?',
  },
  contactoPage: {
    breadcrumb: 'Contact',
    loading: 'Loading…',
    heroTitleDefault: 'Contact us',
    heroSubtitleDefault: 'We are here to help you with all your real estate needs',
    seoTitleDefault: 'Contact',
    seoDescriptionDefault: 'Contact us for all your real estate needs',
    seoKeywordsDefault: 'real estate contact, real estate offices',
    talkHeading: 'Shall we talk?',
    talkSubtitle: 'Tell us what you need and our team will get back to you as soon as possible.',
    writeToUsTitle: 'Write to us',
    writeToUsSubtitle: 'Fill out the form and we will get in touch within 24 hours.',
    contactInfoTitle: 'Contact information',
    phoneLabel: 'Phone',
    callNow: 'Call now',
    emailLabel: 'Email',
    sendEmail: 'Send email',
    openWhatsApp: 'Open WhatsApp',
    officeLabel: 'Office',
    portalsHeading: 'You can also find us on',
    portalsSubtitle: 'We are present on the leading real estate portals so you can browse our properties wherever is most convenient for you.',
    viewProfile: 'View profile',
    messageSentHeading: 'Message sent!',
    sendAnotherMessage: 'Send another message',
    selectOption: 'Select an option',
    mainOffice: 'Main office',
    officeImageAlt: 'Office {{city}}',
    managerLabel: 'Manager: {{name}}',
    scheduleTitle: 'Opening hours:',
    scheduleWeekdays: 'Mon-Fri: {{hours}}',
    scheduleSaturday: 'Sat: {{hours}}',
    scheduleSunday: 'Sun: {{hours}}',
    call: 'Call',
    viewMap: 'View map',
    portalDefaultIdealistaDesc: 'Find our properties on Spain\'s leading real estate portal.',
    portalDefaultFotocasaDesc: 'We also list our homes on Fotocasa.',
    portalDefaultHabitacliaDesc: 'Buy, sell and rent flats listed on Habitaclia.',
    portalCidenarIdealistaDesc: 'All our properties on Spain\'s leading real estate portal.',
    portalCidenarFotocasaDesc: 'Find our homes in Pamplona and Navarra on Fotocasa.',
    portalCidenarHabitacliaDesc: 'Buy, sell and rent flats in Navarra, also listed on Habitaclia.',
  },
  home: {
    siteLoadError: 'The site could not be loaded.',
    featuredTitle: 'Featured Properties',
    contactTitle: 'Contact Us',
    phoneLabel: 'Phone',
    emailLabel: 'Email',
    whatsappLabel: 'WhatsApp',
    addressLabel: 'Address',
  },
  quienesSomosPage: {
    fallbackHeroTitle: 'About Us',
    fallbackHeroSubtitle: '15 years building trust in the real estate sector',
    fallbackSeoDescription: 'Discover our history, team and values',
    fallbackSeoKeywords: 'about us, real estate history, professional team',
    loading: 'Loading…',
  },
};
